module.exports = "preLoaders: [{\n  test: /\\.(jsx?|es6)$/,\n  exclude: ['node_modules'],\n  loader: 'mog-script'\n}]\n"


//////////////////
// WEBPACK FOOTER
// ./instructions/webpack-preloader-example.txt
// module id = 107
// module chunks = 0